import ShareForwardIcon from '@/assets/icons/Share-Forward';
import { Button } from '@/components/ui/button';
import { CloudDownload } from 'lucide-react';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface TActions {
  id: string;
  regnum: string;
  isLoading?: boolean;
  show?: boolean;
  onSubmit: any;
  setOpen: (a: boolean) => void;
  isSubmit: boolean;
  setTab: (a: string) => void;
  isLoadingPro: boolean;
}

export const Actions: FC<TActions> = ({
  id,
  regnum,
  isLoading,
  show = false,
  onSubmit,
  setOpen,
  isSubmit,
  setTab,
  isLoadingPro,
}) => {
  const { t } = useTranslation();
  const form = useFormContext();

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-5">
        {!isLoading ? (
          <div className="flex items-center gap-4">
            <p className="text-lg font-semibold text-green-default">{regnum}</p>
            <div className="flex items-center gap-2">
              <Button variant="ghost" className="p-0">
                <CloudDownload className="stroke-cyan-default" />
              </Button>
              <a
                href={`https://crop2.agro.uz/?land=${id}`}
                target="_blank"
                rel="noopener noreferrer"
                className=" rounded hover:bg-muted transition"
              >
                <ShareForwardIcon />
              </a>
            </div>
          </div>
        ) : (
          <div className="h-9 bg-gray-200 rounded animate-pulse w-32" />
        )}
      </div>

      {/* <div className="flex items-center">
        {show && (
          <>
            <Button
              type="button"
              variant="outline"
              className="ml-5 rounded-[10px] border-green-default"
              onClick={() => setOpen(true)}
            >
              <span>{t('create.project')}</span>
            </Button>

            {isSubmit && (
              <>
                <Button
                  type="button"
                  onClick={() => {
                    setTab('all');
                    form.reset();
                  }}
                  variant="outline"
                  className="ml-2.5 rounded-[10px]"
                >
                  <span>{t('clean')}</span>
                </Button>
                <Button
                  type="button"
                  onClick={onSubmit}
                  variant="secondary"
                  className="ml-2.5 rounded-[10px]"
                  disabled={isLoadingPro}
                >
                  <span>{t('save')}</span>
                </Button>
              </>
            )}
          </>
        )}
      </div> */}
    </div>
  );
};
